var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page page--container"},[_c('Hero'),_c('SliderBlockOne'),_c('SliderBlockTwo'),_c('InfoCardsBlock'),_c('ThumbnailCardsBlock'),_c('SliderBlockThree'),_c('BlogList'),_c('Sponse')],1)}
var staticRenderFns = []

export { render, staticRenderFns }